.heading {
  margin-bottom: 16px;
}

.alertSpacing {
  margin-top: 16px;
  margin-bottom: 16px;
}

.alertBody {
  margin-bottom: 8px;
}

.shapeGrid {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.noteGrid {
  margin-top: 32px;
  margin-bottom: 32px;
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.noteButton {
  text-transform: none;
}

.startButton {
  margin-top: 32px;
  margin-bottom: 32px;
}
